import React, { FC } from 'react';
import { ChevronLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { MagnifyingGlassIcon as SearchIcon } from '@heroicons/react/24/solid';
// import UtilitySection from '../../../utility-section';
import Button from '@/components/atoms/button';
import { useFormat } from '../../hooks/useFormat';

import useIsCurrentPage from '@/lib/hooks/useIsCurrentPage';
import Typography from '@/components/atoms/typography';
import Link from '@/components/atoms/link';
import HeaderLogo from '../../header-logo';

export interface Props {
  logo: any;
  logoLink: any;
  categories: any[];
  onArrowClick: () => void;
  hideHeaderMenu: () => void;
  showSearchBar?: boolean;
  setShowSearchBar?: any;
  name: string
}

const MobileMenuHeader: FC<Props> = ({
  onArrowClick,
  logo,
  logoLink,
  hideHeaderMenu,
  categories,
  showSearchBar,
  setShowSearchBar,
  name

}) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const homePage = useIsCurrentPage(['/au/', '/nz/'])
  return (
    <div className="flex items-center w-full justify-between border-b border-neutral-400 px-4 sm:px-8 min-h-[64px]">
      <div className="">
        <HeaderLogo logo={logo} logoLink={logoLink} imageClassName="flex h-[100px] w-[236px] text-16 font-bold" />
      </div>
      <div className="flex h-full items-center gap-x-2">
        {/* {!homePage && (
          <div className="p-2">
            <SearchIcon
              className="h-6 w-6 fill-secondary-black stroke-0"
              onClick={() => setShowSearchBar(!showSearchBar)}
            />
          </div>
        )} */}
        <div className="w-fit cursor-pointer p-2">
          {/* <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.25 16.3625L4.06967 20L5.45001 12.6956L0.25 7.63932L7.28345 6.76248L10.25 0L13.2166 6.76248L20.25 7.63932L15.0501 12.6956L16.4304 20L10.25 16.3625ZM10.25 14.2508L13.9711 16.4409L13.14 12.0431L16.2708 8.99881L12.0361 8.47085L10.25 4.39928L8.46391 8.47085L4.2292 8.99881L7.36002 12.0431L6.52894 16.4409L10.25 14.2508Z" fill="#666666" />
          </svg> */}
          <Link link={'/'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clipPath="url(#clip0_5296_10875)">
                <path d="M10.7071 2.29289C10.3166 1.90237 9.68342 1.90237 9.29289 2.29289L2.29289 9.29289C1.90237 9.68342 1.90237 10.3166 2.29289 10.7071C2.68342 11.0976 3.31658 11.0976 3.70711 10.7071L4 10.4142V17C4 17.5523 4.44772 18 5 18H7C7.55228 18 8 17.5523 8 17V15C8 14.4477 8.44772 14 9 14H11C11.5523 14 12 14.4477 12 15V17C12 17.5523 12.4477 18 13 18H15C15.5523 18 16 17.5523 16 17V10.4142L16.2929 10.7071C16.6834 11.0976 17.3166 11.0976 17.7071 10.7071C18.0976 10.3166 18.0976 9.68342 17.7071 9.29289L10.7071 2.29289Z" fill="#090909" />
              </g>
              <defs>
                <clipPath id="clip0_5296_10875">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Link>
        </div>
        {name && (
          <div className="w-[25px] h-[25px] rounded-[100px] flex items-center justify-center bg-black">
            <Typography className="text-[14px] !leading-[19px] text-white !font-[600]">
              {name?.charAt(0)?.toUpperCase() || 'M'}
            </Typography>
          </div>
        )}
        <Button
          variant="ghost"
          size="xs"
          onClick={hideHeaderMenu}
          title={formatMessage({ id: 'close', defaultMessage: 'Close' })}
          className="!p-0"
        >
          <XMarkIcon className="w-6 text-secondary-black" />
        </Button>
      </div>
    </div>
  );
};

export default MobileMenuHeader;